import SEO, { type Crumb } from '@/components/SEO';
import PageHeader from '@/components/PageHeader';
import ContentIndex from '@/components/ContentIndex';
import CTABand from '@/components/CTABand';
import { contentBySection, staticPage } from '@/lib/content';

const Notes = () => {
  const page = staticPage('/notes');
  const items = contentBySection('notes');
  const crumbs: Crumb[] = [
    { name: 'Home', href: '/' },
    { name: 'Field notes', href: '/notes' },
  ];
  return (
    <>
      <SEO title={page.title} description={page.description} path="/notes" breadcrumbs={crumbs} />
      <PageHeader
        crumbs={crumbs}
        label="Field notes"
        title="What we found on the job"
        lead="Working notes from WebCenter and Fusion Middleware engagements. The specific patch, the specific component, the specific gotcha — written for the administrator who has run this estate for years."
      />
      <section className="container py-14 md:py-16">
        <ContentIndex
          items={items}
          emptyHeading="Field notes are being written."
          emptyBody="The first notes are in draft. Until they land, the upgrade and migration hubs carry the substance."
        />
      </section>
      <CTABand variant="engineer" />
    </>
  );
};

export default Notes;
